import { CardElement } from '@stripe/react-stripe-js'
import {
  type StripeCardElement,
  type StripeCardElementOptions,
  type StripeElementChangeEvent,
} from '@stripe/stripe-js'
import cx from 'classnames'
import { FormGroup, Help } from '@/components/Form'
import styles from './CardInput.module.css'

export interface CardInputProps {
  error?: string
  isDisabled: boolean
  onChange: (event: StripeElementChangeEvent) => unknown
  onReady: (element: StripeCardElement) => unknown
  testId?: string
}

export function CardInput({
  error,
  isDisabled,
  onChange,
  onReady,
  testId,
}: CardInputProps) {
  return (
    <FormGroup label="Credit or debit card" testId={testId}>
      <CardElement
        onChange={onChange}
        onReady={onReady}
        options={{
          ...CARD_ELEMENT_OPTIONS,
          disabled: isDisabled,
          classes: {
            ...CARD_ELEMENT_OPTIONS.classes,
            // Needed since we also populate errors ourselves.
            base: cx(
              CARD_ELEMENT_OPTIONS.classes?.base,
              error && styles.danger,
              isDisabled && styles.disabled,
            ),
          },
        }}
      />
      <Help error={error} />
    </FormGroup>
  )
}

const CARD_ELEMENT_OPTIONS: StripeCardElementOptions = {
  hidePostalCode: true,
  classes: {
    base: styles.control,
    invalid: styles.danger,
    focus: styles.focused,
  },
}
